module.exports = __webpack_public_path__ + "static/media/app-pawdate-map.df1a153b.jpeg";